import * as stylex from '@stylexjs/stylex';
import { colors } from '@seeqdev/qomponents/colors.stylex';

export const templateStyles = stylex.create({
  sectionHeading: { fontSize: '0.875rem', fontWeight: 600 },
  versionPickerHeading: { marginBottom: '0.25rem', fontSize: '0.875rem', fontWeight: 600 },
  descriptionLabel: { marginBottom: 0, fontSize: '0.875rem', fontWeight: 600 },
  outputSection: {
    marginBottom: '15px',
    width: '100%',
    alignItems: 'center',
    borderBottomWidth: '1px',
    borderLeftWidth: '1px',
    borderRightWidth: '1px',
    borderStyle: 'solid',
    borderColor: colors.templateOutputBorder,
    borderRadius: '0.25rem',
  },
  name: { paddingLeft: 0, paddingRight: 0 },
});
